import { createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../api";
import { apiUrlV1 } from "../../config/config";
import { Currency, CurrencyData } from "../../entities/currency";
import { addNotification } from "../Notification/notificateStore";

const BASE = `${apiUrlV1}/organization/wallet/currency`;

export const getCurrencies = createAsyncThunk(
  "currency/get-currencies",
  async (): Promise<CurrencyData[]> => {
    const req = await agent.get(BASE);
    if (req.ok) {
      return (await req.json()) as CurrencyData[];
    }
    return [];
  }
);

export const postCurrency = createAsyncThunk(
  "currency/post-currency",
  async (params: { data: Currency }, thunksApi): Promise<CurrencyData> => {
    try {
      const response = await agent.post(BASE, { body: JSON.stringify(params.data) });
      if (response.ok) {
        const data = await response.json();
        thunksApi.dispatch(addNotification({ status: "success", text: "Successfully saved" }));
        thunksApi.dispatch(getCurrencies());
        return data as CurrencyData;
      }
      const error = (await response.json()) as { message: string };
      thunksApi.dispatch(addNotification({ status: "error", text: error.message }));
      throw Error(error.message);
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const patchCurrency = createAsyncThunk(
  "currency/patch-currency",
  async (params: { data: Partial<Currency>; code: string }, thunksApi): Promise<CurrencyData> => {
    try {
      const response = await agent.patch(`${BASE}/${params.code}`, { body: JSON.stringify(params.data) });
      if (response.ok) {
        const data = await response.json();
        thunksApi.dispatch(addNotification({ status: "success", text: "Successfully saved" }));
        thunksApi.dispatch(getCurrencies());
        return data as CurrencyData;
      }
      const error = (await response.json()) as { message: string };
      thunksApi.dispatch(addNotification({ status: "error", text: error.message }));
      throw Error(error.message);
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const deleteCurrency = createAsyncThunk(
  "currency/delete-currency",
  async (params: { code: string }, thunksApi): Promise<void> => {
    try {
      const response = await agent.delete(`${BASE}/${params.code}`);
      if (response.ok) {
        thunksApi.dispatch(addNotification({ status: "success", text: "Currency deleted" }));
        thunksApi.dispatch(getCurrencies());
        return;
      }
      const error = (await response.json()) as { message: string };
      thunksApi.dispatch(addNotification({ status: "error", text: error.message }));
      throw Error(error.message);
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);
